
import { EventBus, TypeEventBus } from '../../../../features/core/utils';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      dialog: false,
      title: 'Advertencia',
      message: '',
      resolve: null as null | ((confirmed: boolean) => void),
    };
  },
  created() {
    EventBus.$on(TypeEventBus.HIGH_CLOUDY_CONFIRM_DIALOG, this.openDialog);
  },
  methods: {
    openDialog({
      message,
      resolve,
    }: {
      message: string;
      resolve: (confirmed: boolean) => void;
    }) {
      this.message = message;
      this.resolve = resolve;
      this.dialog = true;
    },
    confirm() {
      this.dialog = false;
      if (this.resolve) {
        this.resolve(true);
      }
    },
    cancel() {
      this.dialog = false;
      if (this.resolve) {
        this.resolve(false);
      }
    },
  },
});
